// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__-Htey","value":"styles_value__2I_sl"};